/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QrCodeDto } from '../../models/qr-code-dto';

export interface QrCodeAdminControllerFindByIdV1$Params {
  id: string;
}

export function qrCodeAdminControllerFindByIdV1(http: HttpClient, rootUrl: string, params: QrCodeAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<QrCodeDto>> {
  const rb = new RequestBuilder(rootUrl, qrCodeAdminControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QrCodeDto>;
    })
  );
}

qrCodeAdminControllerFindByIdV1.PATH = '/api/v1/qr-codes/admin/{id}';
